
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.535.07h-21a1.5 1.5 0 00-1.5 1.5v21a1.5 1.5 0 001.5 1.5h10a.5.5 0 100-1h-4.5v-16h16v4.5a.5.5 0 101 0v-10a1.5 1.5 0 00-1.5-1.5zm-21 1h4.5v5h-5v-4.5a.5.5 0 01.5-.5zm4.5 22h-4.5a.5.5 0 01-.5-.5V7.07h5zm1-17v-5h15.5a.5.5 0 01.5.5v4.5z"}}),_c('path',{attrs:{"d":"M15.173 17.54a.5.5 0 00.674-.739l-1.021-.931h6.709a.5.5 0 000-1h-6.709l1.021-.93a.5.5 0 00-.674-.739L13.2 15l-.006.01a.447.447 0 00-.088.122.351.351 0 00-.027.04.49.49 0 000 .4.456.456 0 00.027.039.468.468 0 00.088.123l.006.009zm7.862 3.231a.489.489 0 00-.042-.2.351.351 0 00-.027-.04.5.5 0 00-.087-.122l-.007-.009-1.972-1.8a.5.5 0 10-.674.739l1.021.931h-6.71a.5.5 0 100 1h6.709l-1.02.93a.5.5 0 00.674.739l1.974-1.8.007-.009a.5.5 0 00.087-.122.351.351 0 00.027-.04.488.488 0 00.04-.197z"}})])
          )
        }
      }
    